import React from 'react';
import { L } from 'harmony-language';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { OrgQueryKeys } from '../../../api/config';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import {
    useEditOrganizationResourceMutation
} from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { ResourcePage } from '../resource-page';
import { useCustomerColumns } from './use-customer-columns';
import { EditCreateCustomer } from './edit-create-customer/edit-create-customer';

export const CustomerManagement = () => {
    const { data: customers, isLoading, organizationId } = useOrganizationQuery(OrgQueryKeys.customers);
    const { mutate: addCustomer, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.customers, L.customer());
    const { mutate: editCustomer, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.customers, L.customer());

    const columns = useCustomerColumns();

    return (
        <ResourcePage
            resourceType='customer'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={customer => customer.customerName}
            data={customers?.filter(x => x.organizationId === organizationId)}
            columns={columns}
            EditCreateComponent={(editCreateProps) => {
                return <EditCreateCustomer
                    existingCustomer={editCreateProps.resource}
                    onSubmit={async (newData) => {
                        if (newData.id) {
                            editCustomer(newData);
                        } else {
                            addCustomer(newData);
                        }
                        editCreateProps.closeModal();
                    }}/>;
            }}/>
    );
};
